import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    comentarios: []
  },
  actions: {
    addComentario ({ commit }, comentario) {
      return new Promise((resolve, reject) => {
        axios.post('/api/comentarios', comentario)
          .then((response) => {
            commit('addComentarioMutation', response)
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteComentario ({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/comentarios/${id}`)
          .then((response) => {
            commit('deleteComentarioMutation', id)
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    }
  },
  mutations: {
    addComentarioMutation (state, c) {
      state.comentarios.push(c)
    },
    deleteComentarioMutation (state, id) {
      const idx = state.comentarios.findIndex((u) => u.id === id) // Buscamos o índice do elemento no array do state
      state.comentarios.splice(idx, 1)
    },
  },
  modules: {}
})